import cx from 'classnames';
import React from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

import './index.css';

const Scroll = React.forwardRef(({ children, className }, ref) => (
  <SimpleBar className={cx({ [className]: !!className })} ref={ref} style={{ maxHeight: '100%' }}>
    {children}
  </SimpleBar>
));

export default Scroll;